import { render, staticRenderFns } from "./UploadDocumentYardTable.vue?vue&type=template&id=2bf74b54&"
import script from "./UploadDocumentYardTable.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentYardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports